import { React, useEffect, useState } from 'react';
import { motion } from "framer-motion";
import GoToSimulation from '../../common/GoToSimulation';
import { rootRoute } from '../../../config';
import pm_introduction from '../assets/pm_introduction.png';
import introduction_pm from '../assets/introduction_pm.png';
import pm_step1 from '../assets/pm_step1.png';
import step2_pm from '../assets/step2_pm.jpg';
import step3_pm from '../assets/step3_pm.png';
import step4_pm from '../assets/step4_pm.jpg';
import pm_step5 from '../assets/pm_step5.png';
import { useOutletContext, useNavigate, useLocation } from "react-router-dom";
import { Link } from 'react-router-dom';
import PmModuleStyle from '../styles/pm.module.css';

const Introduction = () => {
  const [simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, isPopupShown, setIsPopupShown, accordionPopup, setAccordionPopup, simObj, setSimObj, getMonth, toggleSimulation, setToggleSimulation, startOverSimulation, isLoader, setIsLoader, setAriaProperty, check_Location] = useOutletContext();
  const navigate = useNavigate();
  const initIntro = () => {
    setSimPopup(false);
    setIsOverlay(false);
    setHeaderPopup(false);
    setIsArtifacts(false);
  }
  const [currentSection, setCurrentSection] = useState(1);
  const handleContinueBtn = () => {
    if (currentSection <= 6) {
      setCurrentSection(currentSection + 1);
    }
  };
  const location = useLocation();
  const fuSkipWalkThruPopups = () => {
    let readStatusLength = simObj?.artifacts?.filter((artifact) => artifact.readstatus == 1).length;
    return (simObj?.currentstep > 0 || simObj?.attemptno > 1 || readStatusLength > 0 || simObj?.decisionHistory != null || simObj?.decisionHistory?.length != 0)
  }
  // const check_Location = () => { 
  //   const queryParams = new URLSearchParams(location.search);
  //   if (queryParams.has('from') && queryParams.get('from') == "footer") {
  //     navigate(`${rootRoute}/im`);
  //   } else {
  //     fuSkipWalkThruPopups() && navigate(`${rootRoute}/pm/simulation`);
  //   }
  // }
  useEffect(() => {
    initIntro();
    if (document.querySelector("footer.footer .container") != null) {
      if (fuSkipWalkThruPopups()) {
        document.querySelector("footer.footer .container").style.justifyContent = "center";
      }
    }
    if (document.querySelector("footer.footer .footer-nav .footer-links li.skip-intro") != null) {
      if (fuSkipWalkThruPopups()) {
        document.querySelector("footer.footer .footer-nav .footer-links li.skip-intro").style.display = "block";
      }
    }
    // if(document.querySelector(".continue-link") != null){
    //   if(fuSkipWalkThruPopups()){
    //     document.querySelector(".continue-link").style.justifyContent = "space-between";
    //   }
    // }
    if (document.querySelectorAll("footer.footer .footer-nav .footer-links li:not(.skip-intro)").length > 0) {
      document.querySelectorAll("footer.footer .footer-nav .footer-links li:not(.skip-intro)").forEach((item) => {
        item.style.display = "none"
      });
    }
    document.title = "Project Management | Introduction";
    return () => {
      if (document.querySelector("footer.footer .container") != null) {
        document.querySelector("footer.footer .container").style.justifyContent = "space-between";
      }
      if (document.querySelector("footer.footer .footer-nav .footer-links li:not(.skip-intro)") != null) {
        document.querySelectorAll("footer.footer .footer-nav .footer-links li:not(.skip-intro)").forEach((item) => {
          item.style.display = "block"
        });
      }
      if (document.querySelector("footer.footer .footer-nav .footer-links li.skip-intro") != null) {
        document.querySelector("footer.footer .footer-nav .footer-links li.skip-intro").style.display = "none";
      }
    }
  }, []);

  useEffect(() => {
    check_Location();
  }, [simObj]);
  return (
    <motion.div className={`${PmModuleStyle.intro} ${PmModuleStyle.sections}`} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
      <div className={`${PmModuleStyle.section}`} style={{ display: currentSection >= 1 ? "block" : "none" }}>
        <div className={`ui stackable two column grid ${PmModuleStyle.ui} ${PmModuleStyle.stackable} ${PmModuleStyle.column} ${PmModuleStyle.grid}`}>
          <div className={`column ${PmModuleStyle.column}`}>
          <h2 className={`${PmModuleStyle['intro-heading']}`}>Introduction</h2>
            <div className={`${PmModuleStyle.content}`}>
              <h3 className={`${PmModuleStyle.situation}`}><strong>The Mission </strong></h3>
              <p>You are the general contractor for a high-end, private residence construction job. You manage teams of subcontractors who work on various aspects of the house, from plumbing and electrical to drywall and landscaping. The homeowners, Robert and Maggie Applebaum, want to be in their new house in {simObj?.laststate?.months} months and will check in with you regularly about its progress. It is your job to make sure daily operations at the site are running smoothly and that the house is completed on time and within budget, without negatively affecting your other building projects.</p>
              <h3 className={`${PmModuleStyle.goal}`}><strong>Your Goal: </strong></h3>
              <p>Complete the house on time, achieve profits of {simObj?.laststate?.profitPercentage}% or greater (meaning you should spend ${simObj?.laststate?.spendTarget} or less of your ${simObj?.laststate?.constructionBudget} budget on all building costs), and keep the subcontractors and homeowners happy. Your reputation is at stake.</p>
            </div>
          </div>
          <div className={`column ${PmModuleStyle.column}`}>
            <div className={`${PmModuleStyle.image}`}>
              <img src={introduction_pm} alt="" />
            </div>  
            <div className={`${PmModuleStyle.instr} ${PmModuleStyle.box}`}>
              <p className={`${PmModuleStyle.bgblue}`}>The simulation will take approximately <strong>25-45 minutes</strong> to complete and can be paused at any time.
              </p>
          </div>         
          </div>
          
        </div>
        <hr aria-hidden="true" />
        <div
          className={`${PmModuleStyle['continue-link']}`}
          style={{ display: currentSection > 1 ? "none" : "flex" }}
        >
          {
            fuSkipWalkThruPopups() && <Link to={`${rootRoute}/pm/simulation`} className={`${PmModuleStyle['skip-intro']}`} role="button">
              <span>{"Skip Intro "}<span aria-hidden="true" role="presentation">{">>"}</span></span>
            </Link>
          }
          <a href="#step1" onClick={handleContinueBtn} role="button">
            {"Continue "}<span aria-hidden="true" role="presentation">{">>"}</span>
          </a>
        </div>
      </div>
      <div className={`${PmModuleStyle.section}`} style={{ display: currentSection >= 2 ? "block" : "none" }}>
        <div className={`${PmModuleStyle.step}`} id="step1">
        <h2>Step 1: Review Documents</h2>
          <div className={`ui stackable two column grid ${PmModuleStyle.ui} ${PmModuleStyle.stackable} ${PmModuleStyle.column} ${PmModuleStyle.grid}`}>
            <div className={`column ${PmModuleStyle.column}`}>
              <div className={`${PmModuleStyle.content}`}>
                <p>Before you start the simulation you will need to review all the emails, text messages, and phone calls. This information will give you further background on this scenario. Through the course of the simulation more messages will appear, keeping you informed of the latest development and apprise you of critical issues, which may affect your decisions through the home build.</p>
              </div>
            </div>
            <div className={`column ${PmModuleStyle.column}`}>
              <div className={`${PmModuleStyle.image}`}>
                <img src={pm_step1} alt="An image displays a section of a webpage with an open email dialog box, along with a phone and messages icon and a list of multiple emails visible on the page." />
              </div>
            </div>
          </div>
          <hr aria-hidden="true" />
          <div
            className={`${PmModuleStyle['continue-link']}`}
            style={{ display: currentSection > 2 ? "none" : "flex" }}
          >
            {
              fuSkipWalkThruPopups() && <Link to={`${rootRoute}/pm/simulation`} className={`${PmModuleStyle['skip-intro']}`} role="button">
                <span>{"Skip Intro "}<span aria-hidden="true" role="presentation">{">>"}</span></span>
              </Link>
            }
            <a href="#step2" onClick={handleContinueBtn} role="button">
              {"Continue "}<span aria-hidden="true" role="presentation">{">>"}</span>
            </a>
          </div>
        </div>
      </div>
      <div className={`${PmModuleStyle.section}`} style={{ display: currentSection >= 3 ? "block" : "none" }}>
        <div className={`${PmModuleStyle.step}`} id="step2">
          <h2>Step 2: Planning & Execution</h2>
          <div className={`ui stackable two column grid ${PmModuleStyle.ui} ${PmModuleStyle.stackable} ${PmModuleStyle.column} ${PmModuleStyle.grid}`}>
            <div className={`column ${PmModuleStyle.column}`}>
              <div className={`${PmModuleStyle.image}`}>
                <img src={step2_pm} alt="An image displays a section of a webpage showing Planning and Execution phase." />
              </div>
            </div>
            <div className={`column ${PmModuleStyle.column}`}>
              <div className={`${PmModuleStyle.content}`}>
                <p><strong>Separate your work into two phases:</strong></p>
                <ol>
                <li><strong>Planning Phase - </strong>Select all sub-contractors before you start the simulation. Your choices will alter Projected Project Cost and the Projected Completion data. Use this information so you can anticipate both an on-time finish and a profit prior to beginning construction.</li>
                <li><strong>Execution Phase - </strong>Review incoming messages as they arrive and revise your project plan as circumstances change during construction.</li>
                </ol>
              </div>
            </div>
          </div>
          <hr aria-hidden="true" />
          <div
            className={`${PmModuleStyle['continue-link']}`}
            style={{ display: currentSection > 3 ? "none" : "flex" }}
          >
            {
              fuSkipWalkThruPopups() && <Link to={`${rootRoute}/pm/simulation`} className={`${PmModuleStyle['skip-intro']}`} role="button">
                <span>{"Skip Intro "}<span aria-hidden="true" role="presentation">{">>"}</span></span>
              </Link>
            }
            <a href="#step3" onClick={handleContinueBtn} role="button">
              {"Continue "}<span aria-hidden="true" role="presentation">{">>"}</span>
            </a>
          </div>
        </div>
      </div>
      <div className={`${PmModuleStyle.section}`} style={{ display: currentSection >= 4 ? "block" : "none" }}>
        <div id="step3" className={`${PmModuleStyle.step}`}>
          <h2>Step 3: Select Contractors</h2>
          <div className={`ui stackable two column grid ${PmModuleStyle.ui} ${PmModuleStyle.stackable} ${PmModuleStyle.column} ${PmModuleStyle.grid} ${PmModuleStyle.step3main}}`}>
            <div className={`column ${PmModuleStyle.column}`}>
              <div className={`${PmModuleStyle.content}`}>
                <p>In both the Planning and Execution Phases of the simulation, you will select or update your choice of subcontractors for each task. At every decision point, you will have 3 options to choose from each offering services at different costs and speeds to complete their work. You may also choose to expedite the work of a given subcontractor by paying for overtime or extra workers. You must click “Save” for your decision to record in your project plan. Make choices that will allow you to finish on-time and in-budget.</p>
              </div>
            </div>
            <div className={`column ${PmModuleStyle.column}`}>
              <div className={`${PmModuleStyle.image}`}>
                <img src={step3_pm} alt="An image showing Select Contractor popup of a webpage." />
              </div>
            </div>
          </div>
          <hr aria-hidden="true" />
          <div
            className={`${PmModuleStyle['continue-link']}`}
            style={{ display: currentSection > 4 ? "none" : "flex" }}
          >
            {
              fuSkipWalkThruPopups() && <Link to={`${rootRoute}/pm/simulation`} className={`${PmModuleStyle['skip-intro']}`} role="button">
                <span>{"Skip Intro "}<span aria-hidden="true" role="presentation">{">>"}</span></span>
              </Link>
            }
            <a href="#step4" onClick={handleContinueBtn} role="button">
              {"Continue "}<span aria-hidden="true" role="presentation">{">>"}</span>
            </a>
          </div>
        </div>
      </div>
      <div className={`${PmModuleStyle.section}`} style={{ display: currentSection >= 5 ? "block" : "none" }}>
        <div id="step4" className={`${PmModuleStyle.step}`}>
        <h2>Step 4: Track Project Progress</h2>
          <div className={`ui stackable two column grid ${PmModuleStyle.ui} ${PmModuleStyle.stackable} ${PmModuleStyle.column} ${PmModuleStyle.grid}`}>
            <div className={`column ${PmModuleStyle.column}`}>
              <div className={`${PmModuleStyle.image}`}>
                <img src={step4_pm} alt="expected vs. actual costs and expected vs. actual task times graphs. Additionally, study the project plan diagram." />
              </div>
            </div>
            <div className={`column ${PmModuleStyle.column}`}>
             
              <div className={`${PmModuleStyle.content}`}>
                <p>Throughout the simulation, pay close attention to the charts that illustrate the project’s expected vs. actual costs and expected vs. actual task times. Additionally, study the project plan diagram carefully as it moves through the various steps of the home build and what options are be available when any problems arise.</p>
              </div>
            </div>
            
          </div>
          <hr aria-hidden="true" />
          <div
            className={`${PmModuleStyle['continue-link']}`}
            style={{ display: currentSection > 5 ? "none" : "flex" }}
          >
            {
              fuSkipWalkThruPopups() && <Link to={`${rootRoute}/pm/simulation`} className={`${PmModuleStyle['skip-intro']}`} role="button">
                <span>{"Skip Intro "}<span aria-hidden="true" role="presentation">{">>"}</span></span>
              </Link>
            }
            <a href="#step5" onClick={handleContinueBtn} role="button">
              {"Continue "}<span aria-hidden="true" role="presentation">{">>"}</span>
            </a>
          </div>
        </div>
      </div>
      <div className={`${PmModuleStyle.section}`} style={{ display: currentSection >= 6 ? "block" : "none" }}>
        <div id="step5" className={`${PmModuleStyle.step} ${PmModuleStyle["track-project-step"]}`}>
          <h2>Step 5: Track Project Profit Matrix</h2>
            <div className={`ui stackable two column grid ${PmModuleStyle.ui} ${PmModuleStyle.stackable} ${PmModuleStyle.column} ${PmModuleStyle.grid}`}>
              <div className={`column ${PmModuleStyle.column}`}>
                <div className={`${PmModuleStyle.image}`}>
                  <img src={pm_step5} alt="Track Project Profit Matrix and homeowner morale meter" />
                </div>
              </div>
              <div className={`column ${PmModuleStyle.column}`}>  
                <div className={`${PmModuleStyle.content}`}>
                  <p>There are two meters to keep track of your main goals. The first is Total Profit. Remember, you want to keep at least {simObj?.laststate?.profitPercentage}% of the total budget for profit. Make good contractor choices to meet this goal.</p>
                  <br />
                  <p>The second is Project Length. You want to finish in {simObj?.deadlinedays} days to make the homeowners happy. If you are tracking beyond this, you won't finish on time. Make good contractor choices and respond to issues to meet this goal.</p>
                  <br />
                  <p>The project management sim requires careful planning and a working knowledge of Critical Path.</p>
                </div>
              </div>
            </div>
          <hr aria-hidden="true" />
          <div
            className={`${PmModuleStyle['continue-link']}`}
            style={{ display: currentSection > 6 ? "none" : "flex" }}
          >
            {
              fuSkipWalkThruPopups() && <Link to={`${rootRoute}/pm/simulation`} className={`${PmModuleStyle['skip-intro']}`} role="button">
                <span>{"Skip Intro "}<span aria-hidden="true" role="presentation">{">>"}</span></span>
              </Link>
            }
            <a href="#cardSec" onClick={handleContinueBtn} role="button">
              {"Continue "}<span aria-hidden="true" role="presentation">{">>"}</span>
            </a>
          </div>
        </div>
      </div>
      <div style={{ display: currentSection >= 7 ? "block" : "none" }}>
        <div className="key-to-succ-sec">
          <div className={`${PmModuleStyle.bggray}`} id="cardSec">
            <div className={`${PmModuleStyle['keys-to-succ']}`}>
              <div style={{ "paddingTop": "20px" }}>
                <h2 className={`${PmModuleStyle['card-heading']}`}>Keys to Success</h2>
              </div>
              <div className={`${PmModuleStyle['card-wrapper']}`}>
                <div className={`ui card ${PmModuleStyle.ui} ${PmModuleStyle.card}`}>
                  <div>
                    <div className={`header center aligned ${PmModuleStyle.header} ${PmModuleStyle.aligned}`}>
                      <h3>Stay Informed</h3>
                    </div>
                  </div>
                  <p className={`content center aligned ${PmModuleStyle.content} ${PmModuleStyle.aligned}`}>
                  Your decisions are only as good as the information they are based on. Pay attention to indicators and read new messages as they come in.
                  </p>
                </div>

                <div className={`ui card ${PmModuleStyle.ui} ${PmModuleStyle.card}`}>
                  <div>
                    <div className={`header center aligned ${PmModuleStyle.header} ${PmModuleStyle.aligned}`}>
                      <h3>Be Adaptable</h3>
                    </div>
                  </div>
                  <p className={`content center aligned ${PmModuleStyle.content} ${PmModuleStyle.aligned}`}>
                  This simulation puts the concepts from your course into a real-world context where circumstances are changing. Don’t be afraid to make decisions when necessary.
                  </p>
                </div>

                <div className={`ui card ${PmModuleStyle.ui} ${PmModuleStyle.card}`}>
                  <div>
                    <div className={`header center aligned ${PmModuleStyle.header} ${PmModuleStyle.aligned}`}>
                      <h3>Be Patient</h3>
                    </div>
                  </div>
                  <p className={`content center aligned ${PmModuleStyle.content} ${PmModuleStyle.aligned}`}>
                  Sometimes the best course of action is to see how your decisions play out over longer time periods.
                  </p>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div className="section">
          <GoToSimulation />
        </div>
      </div>
    </motion.div>
  )
}

export default Introduction